<style>

.space{
  margin-top: 150px;
}

</style>

<Header>Search</Header>
<div class="has-header"></div>

<!-- <SearchInput></SearchInput> -->

<!-- <SearchResults></SearchResults> -->

<div class="center space">
  <h3>Coming Soon...</h3>
</div>

<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import SearchInput from "../components/SearchInput.svelte";
import SearchResults from "../components/SearchResults.svelte";

</script>